<tui-scrollbar>
  <cdk-virtual-scroll-viewport
    #viewport
    tuiScrollable
    class="viewport tui-zero-scrollbar"
    [itemSize]="45"
    [maxBufferPx]="500"
    [minBufferPx]="400"
  >
    <table
      tuiTable
      [columns]="columns"
    >
      <thead>
        <tr tuiThGroup>
          <ng-container *ngFor="let column of columns; let index = index">
            <th
              *tuiHead="column"
              tuiTh
              [sticky]="true"
              [style.top.px]="-viewport['_renderedContentOffset']"
            >
              {{ titlesColumns?.length ? titlesColumns[index] : column }}
            </th>
          </ng-container>
        </tr>
      </thead>
      <tbody tuiTbody [data]="data">
        <tr
          *cdkVirtualFor="let item of data; let index = index"
          tuiTr
        >
          <ng-container *ngFor="let column of columns">
            <td
              *tuiCell="column"
              tuiTd
            >
              {{ item[column] }}
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </cdk-virtual-scroll-viewport>
</tui-scrollbar>
